import { render } from "./ImageClipHandler.vue?vue&type=template&id=e9da1d6a&scoped=true&ts=true"
import script from "./ImageClipHandler.vue?vue&type=script&lang=ts"
export * from "./ImageClipHandler.vue?vue&type=script&lang=ts"

import "./ImageClipHandler.vue?vue&type=style&index=0&id=e9da1d6a&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9da1d6a"]])

export default __exports__